import React, { useCallback, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SlideHook } from './components/SlideHook';
import { SlidePoll } from './components/SlidePoll';
import { SlideFeedback } from './components/SlideFeedback';
import { SlideExpectation } from './components/SlideExpectation';
import { SlideEvidence } from './components/SlideEvidence';
import { SlideTension } from './components/SlideTension';
import { SlideInvite } from './components/SlideInvite';
const slideVariants = {
  enter: {
    opacity: 0,
    y: 40
  },
  center: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -30
  }
};
export function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [pollAnswer, setPollAnswer] = useState<number | null>(null);
  const [expectationAnswer, setExpectationAnswer] = useState<number | null>(null);
  const [direction, setDirection] = useState(1);
  const goToNext = useCallback(() => {
    setDirection(1);
    setCurrentSlide(prev => Math.min(prev + 1, 6));
  }, []);
  const handlePollAnswer = useCallback((answerIndex: number) => {
    setPollAnswer(answerIndex);
  }, []);
  const handleExpectationAnswer = useCallback((answerIndex: number) => {
    setExpectationAnswer(answerIndex);
  }, []);
  const handleRestart = useCallback(() => {
    setDirection(-1);
    setCurrentSlide(0);
    setPollAnswer(null);
    setExpectationAnswer(null);
  }, []);
  const renderSlide = () => {
    switch (currentSlide) {
      case 0:
        return <SlideHook key="hook" onNext={goToNext} data-id="element-0" />;
      case 1:
        return <SlidePoll key="poll" onNext={goToNext} onAnswer={handlePollAnswer} data-id="element-1" />;
      case 2:
        return <SlideFeedback key="feedback" onNext={goToNext} pollAnswer={pollAnswer} data-id="element-2" />;
      case 3:
        return <SlideExpectation key="expectation" onNext={goToNext} onAnswer={handleExpectationAnswer} data-id="element-3" />;
      case 4:
        return <SlideEvidence key="evidence" onNext={goToNext} expectationAnswer={expectationAnswer} data-id="element-4" />;
      case 5:
        return <SlideTension key="tension" onNext={goToNext} data-id="element-5" />;
      case 6:
        return <SlideInvite key="invite" onRestart={handleRestart} data-id="element-6" />;
      default:
        return null;
    }
  };
  return <div className="w-full h-screen bg-white relative overflow-hidden" data-id="element-7">
      {/* Takeda logo - top right */}
      <motion.div className="absolute top-5 right-5 z-50" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.5,
      duration: 0.8
    }} data-id="element-8">
        <img src="https://cdn.magicpatterns.com/uploads/eTfkzcG3fiuinch9NVPJME/Screenshot_2026-03-24_at_08.34.05.png" alt="Takeda" className="h-5 sm:h-6 object-contain opacity-90" data-id="element-9" />
      </motion.div>

      {/* Subtle ambient gradient - light theme */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-500/[0.03] rounded-full blur-3xl" data-id="element-11" />
        <div className="absolute bottom-0 left-1/4 w-[600px] h-[300px] bg-red-500/[0.02] rounded-full blur-3xl" data-id="element-12" />
      </div>

      {/* Slide content */}
      <AnimatePresence mode="wait" data-id="element-13">
        <motion.div key={currentSlide} className="w-full h-full" variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} data-id="element-14">
          {renderSlide()}
        </motion.div>
      </AnimatePresence>
    </div>;
}